import styled from 'styled-components'

type Props = {
  icon?: boolean
}

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
  align-items: center;
  border-radius: 0.5rem;
`

export const Icon = styled.i`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5rem;
  height: 5rem;
  margin: 1rem;
  background-color: #c8e0f7;
  border-radius: 8px;
  > svg {
    background-color: #fff;
    border-radius: 100%;
  }
`

export const Content = styled.div<Props>`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem 1.5rem;
  align-items: ${(props) => (props.icon ? 'flex-start' : 'center')};
`

export const Value = styled.h1`
  font-size: ${(props) => props.theme.font.text2xl};
`
export const SubValue = styled.span``
